import React, { useState, useEffect } from 'react';
import Strapi from '../../services/strapi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import ArticleField from '../ArticleField';

interface ReadInternProps {
	value: any[],
	onChange: (new_value: any[]) => void,
};

const LinkToDossier = (props: ReadInternProps) => {
	const [options, setOptions] = useState<any[]>([]);
    const [inputValue, setInputValue] = useState<string>("");

	useEffect(() => {
		const params: any = {
			_limit: 10,
			title_contains: inputValue,
		};

		Strapi.get("dossiers", params, {}).then((r) => {
			setOptions(r);
		});
    }, [inputValue]);
	return <ArticleField label="Dossiers Liés">
        <Autocomplete
			multiple
			value={props.value}
			options={options}
			onInputChange={(_, newValue) => {
                setInputValue(newValue);
			}}
        	renderInput={(params) => (
				<TextField {...params} fullWidth/>
			)}
			getOptionLabel={(option) => option.title || option.data.title || ""}
			onChange={(e, changedValue) => {
				if (props.onChange) {
					props.onChange(changedValue);
				}
			}}
		/>
    </ArticleField>
};

export default LinkToDossier;
